export const FaqList = [
  {
    id: "headingOne",
    controls: "collapseOne",
    expanded: true,
    btnClass: "",
    contentClass: "show",
    title: "How stay calm from the first time?",
    details: `LessAccounting is 100% web-based, meaning it can be
    accessed from anywhere and there’s no software to
    install on your computer. You can easily use
    LessAccounting on your iPhone or any Android mobile
    device with our cloud accounting. That is what makes it
    the best small business accounting software options
    among accounting programs.`,
  },
  {
    id: "headingTwo",
    controls: "collapseTwo",
    expanded: false,
    btnClass: "collapsed",
    contentClass: "",
    title: "Our proprietary enables Quality?",
    details: `LessAccounting is 100% web-based, meaning it can be
    accessed from anywhere and there’s no software to
    install on your computer. You can easily use
    LessAccounting on your iPhone or any Android mobile
    device with our cloud accounting. That is what makes it
    the best small business accounting software options
    among accounting programs.`,
  },
  {
    id: "headingThree",
    controls: "collapseThree",
    expanded: false,
    btnClass: "collapsed",
    contentClass: "",
    title: "Locate Clean USA Office Near You.",
    details: `LessAccounting is 100% web-based, meaning it can be
    accessed from anywhere and there’s no software to
    install on your computer. You can easily use
    LessAccounting on your iPhone or any Android mobile
    device with our cloud accounting. That is what makes it
    the best small business accounting software options
    among accounting programs.`,
  },
  {
    id: "headingFour",
    controls: "collapseFour",
    expanded: false,
    btnClass: "collapsed",
    contentClass: "",
    title: "Visit our office and see services.",
    details: `LessAccounting is 100% web-based, meaning it can be
    accessed from anywhere and there’s no software to
    install on your computer. You can easily use
    LessAccounting on your iPhone or any Android mobile
    device with our cloud accounting. That is what makes it
    the best small business accounting software options
    among accounting programs.`,
  },
  // {
  //   id: "headingFive",
  //   controls: "collapseFive",
  //   expanded: false,
  //   btnClass: "collapsed",
  //   contentClass: "",
  //   title: "How does the 30-day free software trial work?",
  //   details: `LessAccounting is 100% web-based, meaning it can be
  //   accessed from anywhere and there’s no software to
  //   install on your computer. You can easily use
  //   LessAccounting on your iPhone or any Android mobile
  //   device with our cloud accounting. That is what makes it
  //   the best small business accounting software options
  //   among accounting programs.`,
  // },
];
